var map = {
	"./aparthotelclub/ic_video_play.png": 393,
	"./beachful/ic_video_play.png": 38241,
	"./castlepedia/ic_video_play.png": 67752,
	"./cocktayl/ic_video_play.png": 24448,
	"./ic_video_play.png": 32702,
	"./luxresortclub/ic_video_play.png": 96000,
	"./parkful/ic_video_play.png": 62347,
	"./prefabworld/ic_video_play.png": 61710,
	"./rooftopclub/ic_video_play.png": 57433,
	"./spaclub/ic_video_play.png": 22011,
	"./worldcasino/ic_video_play.png": 10921,
	"./zoopedia/ic_video_play.png": 29655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52642;